<template lang="pug">
  div.payments-find
    h2 {{lang['Find and print payment']}}
    form.form-inline
      .form-group
        label.label {{lang['Restaurant (mpk)']}}
          sup *
        input.form-control(v-model="mpk")
      .form-group
        label.label {{lang['Sum']}}
        input.form-control(v-model="total")
      .form-group
        label.label {{lang['MicrosId']}}
        input.form-control(v-model="microsid")
      .form-group
        label.label {{lang['Date from']}}
        date-picker(v-model="dateFrom" :config="pickerConfig")
      .form-group
        label.label {{lang['Date to']}}
        date-picker(v-model="dateTo" :config="pickerConfig2")
      button.btn.btn-default(@click.prevent="getData()") {{lang['Find']}}
      br
      .small * {{lang['required']}}
    h3(v-if="payments.length > 0") {{lang['First 100 found (doubleclick to print)']}}:
    table.table.table-condensed.table-hover(v-if="payments.length > 0")
      thead
        th {{lang['Date']}}
        th {{lang['Name']}}
        th {{lang['Status']}}
        th {{lang['MicrosId']}}
        th {{lang['Total']}}
      tbody
        tr(v-for="payment in payments" :key="payment.id" :class="payment.status | paymentClass" @dblclick="getPayment(payment.id)")
          td {{payment.createdAt | formatDateTime}}
          td {{payment.name}}
          td {{payment.status | statusDict}}
          td {{payment.microsId}}
          td {{payment.total | moneyFormat}}
</template>
<script>
export default {
  props: ['lang'],
  data () {
    return {
      pickerConfig: {format: 'YYYY-MM-DD HH:mm', maxDate: this.$moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'), minDate: false, icons: {time: 'fa fa-lg fa-clock'}},
      pickerConfig2: {format: 'YYYY-MM-DD HH:mm', maxDate: this.$moment().format('YYYY-MM-DD HH:mm'), minDate: false, icons: {time: 'fa fa-lg fa-clock'}},
      mpk: '',
      total: '',
      microsid: '',
      dateFrom: this.$moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
      dateTo: this.$moment().format('YYYY-MM-DD HH:mm'),
      payments: [],
      usePayment: null
    }
  },
  methods: {
    getData () {
      if (this.mpk.length < 1) {
        return this.$notify('Restauracja (MPK) nie może być pusta', 'error')
      }
      this.$http.post('device-payment-log/find', { mpk: this.mpk, microsid: this.microsid, total: this.total, dateFrom: this.dateFrom, dateTo: this.dateTo })
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (process.env.NODE_ENV !== 'production') {
            console.log(data)
          }
          this.payments = data
        })
    },
    getPayment (id) {
      this.$http.post('device-payment-log/get', { id })
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (process.env.NODE_ENV !== 'production') {
            console.log(data)
          }
          this.usePayment = data.receipt.join('<br>')
          const win = window.open()
          win.document.write(this.usePayment)
          win.print()
          win.close()
        })
    },
    closePayment () {
      this.showPayment = false
      this.usePayment = null
    }
  }
}
</script>
<style lang="sass">
.payments-find
  .label
    margin-left: 8px
    margin-right: 4px
    font-size: 100%
  .btn
    margin-left: 8px
  table
    margin-top: 8px
    td
      cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/payments/Find.vue